export const navCopy = {
  skip_to_content: "スキップしてメインコンテンツに進む",
  nav_documentation: "ドキュメント",
  nav_documentation_short: "ドキュメント",
  nav_download: "ダウンロード",
  nav_community: "コミュニティ",
  nav_playground: "プレイグラウンド",
  nav_playground_short: "プレイグラウンド",
  nav_handbook: "ハンドブック",
  nav_tools: "ツール",
  nav_search_placeholder: "検索",
  nav_search_aria: "TypeScript サイト内を検索",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_version_stable_prefix: " が最新バージョンです",
  nav_version_between: "。 ",
  nav_version_beta_prefix: " がベータテストバージョンです。",
  nav_version_rc_prefix: " がRCです。",
  nav_this_page_in_your_lang: "このページを日本語で利用しますか？",
  nav_this_page_in_your_lang_open: "利用する",
  nav_this_page_in_your_lang_no_more: "質問を表示しない",
}
